import { getCurrentBrand } from '@/utils/getCurrentBrand';
import Script from 'next/script';
import React from 'react';

interface GtmProps {
  gtmId: string;
}

const Gtm: React.FC<GtmProps> = ({ gtmId }) => {
  const { host } = getCurrentBrand();
  const gtmScriptBaseUrl = `https://analytics.${host}/gtm.js`;

  return (
    <Script id="gtm-tracking">{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='${gtmScriptBaseUrl}?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`}</Script>
  );
};

export default Gtm;
